type SafePanicErrorHandler = (error: Error) => void;
type SafePanicParams = {
  message: string;
  fallback: unknown;
  onError?: SafePanicErrorHandler;
};

// Tells typescript that this case is impossible.
// This is cleaner than non-null assertions and also
// useful for exhaustive switch statements
export const panic = (message: string): never => {
  console.error(message);
  throw new Error(message);
};

export const safePanic = ({ message, fallback, onError }: SafePanicParams): never => {
  console.error(message);
  onError?.(new Error(message));
  return fallback as never;
};
